// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCdLhAiyWsKGA57qbLlRTTT2bJgJOxW3G4",
    authDomain: "jedibizcms.firebaseapp.com",
    projectId: "jedibizcms",
    storageBucket: "jedibizcms.appspot.com",
    messagingSenderId: "505461301895",
    appId: "1:505461301895:web:78e50a6bfc565664a4ce22",
    measurementId: "G-NDMFTQ5PBV"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
